import { render } from "./Resource.vue?vue&type=template&id=2b58af0d"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__